// Power BI Service for handling authentication and embed URLs via backend API
class PowerBIService {
    constructor() {
        this.config = {
            workspaceId: 'bcb18a0f-e701-4e30-88a6-ddea7062043c',
            reportId: '76fe3ce1-98c6-4a82-8361-9becdd0e859e',
            tenantId: '94dbcc7c-6e32-4329-a59a-3fb79b6fb70e'
        };
        
        this.baseUrl = 'https://muddemal.patterneffects.in/api';
        this.embedToken = null;
        this.tokenExpiry = null;
        this.store = null;
    }

    setStore(store) {
        this.store = store;
    }

    getAuthToken() {
        if (this.store && this.store.getters.token) {
            return this.store.getters.token;
        }
        return sessionStorage.getItem('token');
    }

    /**
     * Get embed token - FIXED VERSION
     * Returns just the token string, not the response object
     */
    async getEmbedToken() {
        try {
            // Check if we have a valid token already
            if (this.embedToken && !this.isTokenExpired()) {
                console.log('Using existing valid embed token');
                return this.embedToken;
            }
            
            const authToken = this.getAuthToken();
            if (!authToken) {
                throw new Error('User is not authenticated. Please log in.');
            }

            console.log('Requesting new embed token from backend...');
            
            const response = await fetch(`${this.baseUrl}/powerbi/embed-token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache'
                },
                body: JSON.stringify({
                    reportId: this.config.reportId,
                    workspaceId: this.config.workspaceId
                })
            });

            if (!response.ok) {
                if (response.status === 401) {
                    this.embedToken = null;
                    this.tokenExpiry = null;
                    throw new Error('Authentication expired. Please log in again.');
                }
                
                const errorText = await response.text();
                throw new Error(`Embed token request failed: ${response.status} - ${errorText}`);
            }

            const embedData = await response.json();
            
            if (!embedData.success) {
                throw new Error(embedData.error || 'Failed to get embed token');
            }

            if (!embedData.embed_token) {
                throw new Error('No embed token received from server');
            }

            // Store the token string directly
            this.embedToken = embedData.embed_token;
            this.tokenExpiry = Date.now() + (embedData.expires_in || 3600) * 1000;
            
            console.log('Embed token obtained successfully');
            console.log('Token length:', this.embedToken.length);
            
            // Return just the token string
            return this.embedToken;
        } catch (error) {
            console.error('Error getting embed token:', error);
            throw error;
        }
    }

    isTokenExpired() {
        if (!this.tokenExpiry) return true;
        // Add 5 minute buffer before actual expiry
        return Date.now() >= (this.tokenExpiry - 300000);
    }

    async refreshReport() {
        try {
            console.log('Refreshing Power BI report...');
            this.embedToken = null;
            this.tokenExpiry = null;
            return await this.getEmbedToken();
        } catch (error) {
            console.error('Error refreshing report:', error);
            throw error;
        }
    }

    updateConfig(newConfig) {
        this.config = { ...this.config, ...newConfig };
        this.embedToken = null;
        this.tokenExpiry = null;
    }
}

// Create and export singleton instance
const powerBIService = new PowerBIService();
export default powerBIService;